import { FC, useEffect, useContext, useState, useLayoutEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { format } from "date-fns";


import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";
import { ToastTypes } from "src/types";

import FooterText from "src/components/footerText";
import ContactAndSafetyInfo from "src/components/contactAndSafetyInfo";
import { TextAlignProps } from "src/components/contactAndSafetyInfo/types";
import { CaseListingType, StatisticsApiResponse } from "./types";
import CustomPieChart from "src/components/manufacturer/customPieChart";
import CaseDetail from "src/components/manufacturer/caseDetail";
import TerritoriesFilter from "src/components/manufacturer/territoriesFilter";
import { TerritoriesSearchProps } from "src/components/manufacturer/territoriesFilter/types";
import CustomLineChart from "src/components/manufacturer/customLineChart";




const DoctorStatistics: FC = (): JSX.Element => {
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const [searchParams, updateSearchParams] = useSearchParams();

  useLayoutEffect(()=>{
    setLoader()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  const [queryParams, changeQueryParams] = useState<TerritoriesSearchProps>({
    start_date:
      searchParams.get("start_date") ||
      format(new Date().setDate(new Date().getDate() - 30), "yyyy-MM-dd"),
    end_date:
      searchParams.get("end_date") ||
      format(new Date().setDate(new Date().getDate() + 1), "yyyy-MM-dd"),
    period: searchParams.get('period') || "",
    filter_type: searchParams.get("filter_type") || "",
    //time: searchParams.get("time") || "",
    type: searchParams.get("type") || "",
    role: searchParams.get("role") || "",
    id:   Number(searchParams.get('id')) || 0,
    search_str:""
    // soc_value: searchParams.get("soc_value") || "",
    // drug_id: searchParams.get("drug_id") || "",
    // user_id: searchParams.get("user_id") || (userData && userData.ref_type === "rep" ? userData.id.toString() : "") || "",
  });

  const { data: statisticsData, mutate: getStatsData } =
    useFetch<StatisticsApiResponse>(APIEndpoints.MANUFACTURE_STATISTICS, queryParams);

  useEffect(() => {
    if (statisticsData) {
      hideLoader();
      if (statisticsData.code === 200) {
        showToast([statisticsData.message], ToastTypes.SUCCESS);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statisticsData]);



  const updateQueryParamsAndCallAPI = (
    updatedQueries: TerritoriesSearchProps,
    isReset: boolean = false
  ): void => {
    if (isReset) {
      updateSearchParams({});
      changeQueryParams({
        start_date: format(
          new Date().setDate(new Date().getDate() - 30),
          "yyyy-MM-dd"
        ),
        end_date: format(
          new Date().setDate(new Date().getDate()),
          "yyyy-MM-dd"
        ),
        period: "",
        filter_type: "",
        //time: "",
        type: searchParams.get("type") || "",
        role: searchParams.get("role") || "",
        id:   Number(searchParams.get('id')) || 0,
        search_str:""

      });
    } else {
      changeQueryParams(updatedQueries);
    }

    setLoader();
    getStatsData({}, {}, updatedQueries);
  };

  const getStatisticsData = () => {
    changeQueryParams(queryParams)
  }



  return (
    <div className="container-fluid overflow-auto pt-3">

      <ContactAndSafetyInfo alignText={TextAlignProps.TEXT_END} textColor={"black"} />

      {statisticsData && (
        <TerritoriesFilter
        defaultQueryParams={queryParams}
        updateQueryParams={updateQueryParamsAndCallAPI}
      />
      )}
      {statisticsData && (
        <CustomLineChart title="Case Volume" LineChartObject={statisticsData.data.case_volume} />      )}
      {statisticsData && (
        <div className="card mt-3">
          <div className="card-header text-center">
            <h4 className="mt-2 mb-0">Transfers</h4>
          </div>
          <div className="card-body text-center text-black">
            <h1 className="mt-2 mb-0"
            >{statisticsData.data.transfers}</h1>
          </div>
        </div>
      )}
       {statisticsData && (
       <div className="row">
        <div className="col-12 col-lg-6">
        <CustomPieChart pieChartObject={statisticsData.data.top_payors} title="Top 10 Payors" />
        </div>
        <div className="col-12 col-lg-6">
        {statisticsData && (
        <CustomPieChart pieChartObject={statisticsData.data.mos} title="Cases By Submission Mode" />
      )}
        </div>
       </div>
      )}
      <div className="row">
        <div className="mt-3">
          {statisticsData && 
            <CaseDetail 
              baseUrl="/statistics" searchParams={queryParams} 
              CaseDetailListType={statisticsData.data.case_listing as unknown as CaseListingType[]}
              forPage="DOCTORSTATS" refreshListing={getStatisticsData}
            />
          }
        </div>
      </div>
      <FooterText footerType="black" />
    </div>
  );
};

export default DoctorStatistics;
